import { css } from '@bts-web/utils-style-engine';
import { SkeletonElement } from '../../../common';

const containerStyles = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'small',
  width: '100%',
});

const subItemsStyles = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'extra_small_2',
});

const rowStyles = css({
  display: 'flex',
  justifyContent: 'space-between',
  gap: 'small',
});

export const FeesForAmountSkeleton = () => (
  <div data-testid="fees-for-amount-skeleton" className={containerStyles}>
    <div className={subItemsStyles}>
      <div className={rowStyles}>
        <SkeletonElement width="56px" height="12px" borderRadius="4px" />
        <SkeletonElement width="64px" height="12px" borderRadius="4px" />
      </div>

      <div className={rowStyles}>
        <SkeletonElement width="40px" height="12px" borderRadius="4px" />
        <SkeletonElement width="48px" height="12px" borderRadius="4px" />
      </div>
    </div>

    <div className={rowStyles}>
      <SkeletonElement width="48px" height="18px" borderRadius="4px" />
      <SkeletonElement width="72px" height="18px" borderRadius="4px" />
    </div>
  </div>
);
